import PicUploader from './VideoUploader.vue'

export default PicUploader